import { render, staticRenderFns } from "./mdf-details-widget.vue?vue&type=template&id=9a0f8d24&"
import script from "./mdf-details-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-details-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-details-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports